"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./FieldCheckbox.scss");

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FieldCheckbox extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onBlur", event => {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    });

    _defineProperty(this, "onFocus", event => {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    });

    _defineProperty(this, "onChange", event => {
      let value;

      if (event.target.checked) {
        value = true || this.props.value;
      } else {
        value = false;
      }

      this.setState({
        value: value
      });

      if (this.props.onChange) {
        this.props.onChange(value, event);
      }
    });

    this.state = {
      value: props.value
    };
  }

  render() {
    const _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          checked = _this$props.checked,
          required = _this$props.required,
          disabled = _this$props.disabled,
          readonly = _this$props.readonly,
          autofocus = _this$props.autofocus;
    const label = this.props.title || this.props.label || "bool";
    return _react.default.createElement(_FormControlLabel.default, {
      control: _react.default.createElement(_Checkbox.default, {
        checked: checked,
        onChange: event => this.onChange(event),
        value: value
      }),
      label: label
    });
    /*
     return (
        
        <label className="admin-field  field--checkbox">
        
            <input type="checkbox" id={id} 
                name={name}
                value={value}
                checked={checked}
                required={required}
                disabled={disabled || readonly}
                autoFocus={autofocus}
                onChange={(event) => this.onChange(event)}
                onBlur={(event) => this.onBlur(event)}
                onFocus={(event) => this.onFocus(event)}
            />
             <i className="checkbox__icon"></i>
            <b className="checkbox__label">{ label }</b>
         </label>
    )
     */
  }

}

_defineProperty(FieldCheckbox, "defaultProps", {
  value: "",
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false
});

var _default = FieldCheckbox;
exports.default = _default;
module.exports = exports.default;